import { createContext, useMemo } from "react";

export const MapContext = createContext();

export default function MapProvider({ children, mapRef }) {
    const value = useMemo(() => {
        const zoomToPoint = async (point) => {
            await mapRef.current?.zoomToPoint(point)
        }

        const reset = async () => {
            await mapRef.current?.reset()
        }   
        return { zoomToPoint, reset }
    }
    , [mapRef])

    return (
        <MapContext.Provider value={value}>
            {children}
        </MapContext.Provider>
    )
}